import { FC } from 'react';

import { styled } from '../theme';

type Props = {
    src: string;
    alt?: string;
    responsive?: boolean;
    rounded?: boolean;
    circle?: boolean;
    thumbnail?: boolean;
    className?: string;
};

const StyledImage = styled('img')<Props>(
    ({ responsive, rounded, circle, thumbnail }) => `
  ${responsive && 'max-width: 100%; height: auto;'}
  ${rounded && 'border-radius: 6px;'}
  ${circle && 'border-radius: 50%;'}
  ${
      thumbnail &&
      `
    padding: 4px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    display: inline-block;
    max-width: 100%;
    height: auto;
  `
  }
`
);

const Image: FC<Props> = (props) => <StyledImage {...props} />;

export default Image;
